import { render, staticRenderFns } from "./DesktopDisplayMobile.vue?vue&type=template&id=220d27b0&scoped=true"
import script from "./DesktopDisplayMobile.vue?vue&type=script&lang=js"
export * from "./DesktopDisplayMobile.vue?vue&type=script&lang=js"
import style0 from "./DesktopDisplayMobile.vue?vue&type=style&index=0&id=220d27b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220d27b0",
  null
  
)

export default component.exports